import * as S from '@effect/schema/Schema';
export var BannerBlockConfig = S.struct({
  typename: S.literal('BannerBlock'),
  id: S.string,
  hash: S.string,
  imageUrl: S.nullable(S.string)
});